import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../views/fragments/button';
import {FormInline} from '../../views/fragments/forms';

export default class ContinuePanel extends React.Component {

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    dom: PropTypes.string.isRequired,
    continueText: PropTypes.string.isRequired,
  };

  static defaultProps = {
    dom: 'div',
    continueText: 'Continue',
  };

  render() {
    const {
      onSubmit,
      onDownload,
      disabled,
      dom,
      continueText,
    } = this.props;

    return (
      <FormInline dom={dom}>
        <Button
         disabled={disabled}
         btnStyle="primary"
         pullRight
         type="submit"
         onClick={
          onSubmit}>
          {continueText}
        </Button>
        <Button
         disabled={disabled}
         btnStyle="primary"
         pullRight
         onClick={
          onDownload}>
          Download
        </Button>
      </FormInline>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/continue-panel/index.js